<template lang="pug">
  v-content.pa-0
    // <v-card v-show="showCart.show">
    v-row(no-gutters)
      v-col(cols='12' xs='12' sm='6' md='4' lg='3' xl='2')
        product-selector(label='Search Product' :products='getActiveProducts()' @selected='productSelected($event)' @showCart='showCart.show=$event') Loading...
      v-col(cols='12' xs='12' sm='6' md='4' lg='3' xl='2')
        e-z-order-list(:orders='cartOrders' :options="{mode: 'cart', seats}") Loading...
</template>
<script>
import { storeMixin } from "../../mixins/storeMixin.js";
import EZOrderList from "../shared/EZOrderList.vue";
import ProductSelector from "../shared/ProductSelector.vue";

export default {
  name: "ezcart",
  mixins: [storeMixin],
  props: {
    showCart: Object,
    sectionKey: String,
    sectionCode: String,
    serviceKey: String,
    seats: Array
  },
  components: { EZOrderList, ProductSelector },
  beforeMount() {
    if (
      !this.myFeatures.eligibleFeatures.includes("INVENTORY") &&
      this.groupProducts.length === 0
    ) {
      this.bindGroupProducts();
    }
  },
  data() {
    return {
      collectionName: "orders",
      editedItem: {}
    };
  },
  computed: {
    cartOrders() {
      return this.serviceOrders
        .filter(o => o.status === this.STATUSES.INCART)
        .sort((o1, o2) => {
          return o2.createdTS - o1.createdTS;
        });
    },
    defaultItem() {
      return {
        _groupKey: this.selectedGroup.id,
        _restaurantKey: this.selectedRestaurant.id,
        _sectionKey: this.sectionKey,
        _serviceKey: this.serviceKey,
        _productKey: "",
        _counterKey: "",
        counterCode: "",
        sectionCode: this.sectionCode,
        productCode: "",
        productName: "",
        quantity: "1",
        billNum: "1",
        taxRate: "",
        tags: [],
        status: 0,
        trace: [],
        sosFlag: false
      };
    }
  },
  methods: {
    productSelected(product) {
      const isFirstOrder =
        this.serviceOrders.filter(o => o.status !== this.STATUSES.INCART)
          .length === 0;
      if (product) {
        Object.assign(this.editedItem, this.defaultItem);
        this.editedItem.seat = this.serviceOrders.length
          ? this.getLatestOrder().seat
          : this.seats[0];
        this.editedItem._productKey = product.id;
        this.editedItem._counterKey =
          product._counterKey || this.counters[0].id;
        this.editedItem.counterCode =
          product.counterCode || this.counters[0].code;
        this.editedItem.productCode = product.code;
        this.editedItem.productName = product.name;
        this.editedItem.rate = product.rate;
        this.editedItem.price = product.rate;
        this.editedItem.taxPlan = product.taxPlan;
        this.createOrder(this.editedItem);
      }
      this.editedItem = {};
      isFirstOrder && this.$emit("activated");
    },
    getActiveProducts() {
      let products = [];
      if (this.myFeatures.eligibleFeatures.includes("INVENTORY")) {
        const openCounterIds = this.counters
          .filter(c => c.status === this.STATUSES.OPEN)
          .map(c => c.id);
        products = this.restaurantProducts.filter(
          p =>
            openCounterIds.includes(p._counterKey) &&
            p.status === this.STATUSES.ACTIVE &&
            (this.myFeatures.eligibleFeatures.includes("INVENTORY")
              ? Number(p.count) > 0
              : true)
        );
      } else {
        products = this.groupProducts.filter(
          p => p.status === this.STATUSES.ACTIVE
        );
      }
      return products;
    },
    getLatestOrder() {
      const latestCreatedTS = Math.max(
        ...this.serviceOrders.map(o => o.createdTS)
      );
      const latestOrder = this.serviceOrders.find(o => {
        return o.createdTS === latestCreatedTS;
      });
      return latestOrder;
    },
    createOrder(order) {
      const payLoad = {
        collectionName: this.collectionName,
        doc: order
      };
      this.createDoc(payLoad);
    },
    async deleteOrder(order) {
      const payLoad = {
        collectionName: this.collectionName,
        docId: order.id
      };
      this.deleteDoc(payLoad);
    }
  }
};
</script>